(function() {
    'use strict';

    angular
        .module('app.choferes')
        .run(appRun);

    // appRun.$inject = ['routehelper'];

    /* @ngInject */
    function appRun(routehelper) {
        routehelper.configureRoutes(getRoutes());
    }

    function getRoutes() {
        return [
            {
                url: '/choferes',
                config: {
                    templateUrl: 'app/choferes/list.html',
                    controller: 'choferes.List',
                    controllerAs: 'vm',
                    title: 'List'
                }
            },
            {
                url: '/editar-chofer/:id?',
                config: {
                    templateUrl: 'app/choferes/edit.html',
                    controller: 'choferes.Edit',
                    controllerAs: 'vm',
                    title: 'Edit'
                }
            }
        ];
    }
})();
